(function() {
  'use strict';

  function openTabbyPopup(url) {
    const modal = document.createElement('div');
    modal.className = 'tabby-popup-modal';

    let closeIconUrl = '';
    const baseUrl = window.location.origin;

    const existingCloseIcon = document.querySelector(
      'img[src*="icon_close.svg"], img[src*="icon-close.svg"], img[src*="close-pop.svg"]'
    );

    if (existingCloseIcon && existingCloseIcon.src) {
      closeIconUrl = existingCloseIcon.src;
    } else {
      closeIconUrl = `${baseUrl}/assets/icon_close.svg`;
    }

    modal.innerHTML = `
      <div class="tabby-popup-overlay"></div>
      <div class="tabby-popup-container">
        <button class="tabby-popup-close" aria-label="Close" type="button">
          <img src="${closeIconUrl}" alt="Close" width="10" height="10" class="tabby-popup-close-icon">
        </button>
        <div class="tabby-popup-iframe-wrapper">
          <iframe src="${url}" class="tabby-popup-iframe" frameborder="0" scrolling="no"></iframe>
        </div>
      </div>
    `;

    const iframe = modal.querySelector('.tabby-popup-iframe');
    if (iframe) {
      iframe.setAttribute('scrolling', 'no');
    }

    document.body.appendChild(modal);

    const isMobile = window.innerWidth < 750;

    if (!isMobile) {
      const scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    }

    const container = modal.querySelector('.tabby-popup-container');
    if (container) {
      container.style.overflowY = 'auto';
      container.style.overflowX = 'hidden';
      container.style.pointerEvents = 'auto';
      container.style.webkitOverflowScrolling = 'touch';

      if (isMobile) {
        container.style.height = '100vh';
        container.style.maxHeight = '100vh';
      }
    }

    if (iframe) {
      iframe.style.pointerEvents = 'auto';
      iframe.style.touchAction = 'manipulation';
    }

    const closeModal = () => {
      if (document.body.contains(modal)) {
        document.body.removeChild(modal);

        // Восстанавливаем скролл для всех случаев (и мобильных, и десктопа)
        const scrollY = document.body.style.top;
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';

        if (scrollY && !isMobile) {
          window.scrollTo(0, parseInt(scrollY || '0') * -1);
        }
      }
    };

    const overlay = modal.querySelector('.tabby-popup-overlay');
    const closeButton = modal.querySelector('.tabby-popup-close');

    if (overlay) {
      overlay.addEventListener('click', closeModal);
    }

    if (closeButton) {
      const handleClose = (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        closeModal();
        return false;
      };

      closeButton.addEventListener('click', handleClose, { passive: false });
      closeButton.addEventListener('touchend', handleClose, { passive: false });
      closeButton.addEventListener('touchstart', (e) => {
        e.stopPropagation();
      }, { passive: false });
    }

    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        closeModal();
        document.removeEventListener('keydown', handleEsc);
      }
    };

    document.addEventListener('keydown', handleEsc);
  }

  window.openTabbyPopup = openTabbyPopup;
})();